module.exports = __webpack_public_path__ + "back-arrow.svg?b7a35c16ee96983497bed8b622f6730d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back-arrow.svg
// module id = 367
// module chunks = 0